import { useCallback } from 'react';

export function useScrollToPostRefGetter(index: number) {
  return useCallback(
    (postId: number) => (postElement: HTMLDivElement | null) => {
      if (index === -1 || postId !== index) {
        return;
      }

      postElement?.scrollIntoView({
        behavior: 'instant'
      });
    },
    [index]
  );
}
